import type { ProcessCellCallbackParams } from '../../../types/common';
import type { UserType } from '../../../types/user';

const emailCellCallback = (params: ProcessCellCallbackParams): string => {
  const userEmail: string = params.value;
  const users: UserType[] = params.context?.users ?? [];
  const targetUser: string | undefined = users.find((user) => user.email === userEmail)?.username;
  const userName: string = targetUser ?? userEmail;
  return userName;
};

export default emailCellCallback;
